"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Translator_1 = require("../Translator");
/**
 * Translates booleans.
 */


var TypeHandlerBoolean =
/*#__PURE__*/
function () {
  function TypeHandlerBoolean() {
    _classCallCheck(this, TypeHandlerBoolean);
  }

  _createClass(TypeHandlerBoolean, [{
    key: "fromRdf",
    value: function fromRdf(literal, validate) {
      switch (literal.value) {
        case 'true':
          return true;

        case 'false':
          return false;

        case '1':
          return true;

        case '0':
          return false;
      }

      if (validate) {
        Translator_1.Translator.incorrectRdfDataType(literal);
      }

      return false;
    }
  }, {
    key: "toRdf",
    value: function toRdf(value, dataFactory) {
      return dataFactory.literal(value ? 'true' : 'false', dataFactory.namedNode(TypeHandlerBoolean.TYPE));
    }
  }]);

  return TypeHandlerBoolean;
}();

TypeHandlerBoolean.TYPE = 'http://www.w3.org/2001/XMLSchema#boolean';
exports.TypeHandlerBoolean = TypeHandlerBoolean;